import React from 'react';
import { Box, Typography, Table, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import { StyledTableCell } from '../../style';
import StyleTextField from '../../styleTextField';

const SmartSamplingTags = ({ smartSampling, smartSamplingTagsErrors, handleSamplingInputChange }) => (
    <>
        {/* Header Row */}
        <Table sx={{ height: '40px' }}>
            <StyledTableCell sx={{ padding: '12px 12px', width: '100%' }} colSpan={3}>
                <Typography
                    sx={{
                        marginRight: '10px',
                        fontSize: '16px',
                        color: '#0047BA',
                        fontWeight: '500',
                    }}
                >
                    Smart Sampling Automated Pipeline Configuration
                </Typography>
            </StyledTableCell>
        </Table>

        {/* Content Rows */}
        {smartSampling?.map((row, index) => (
            <Table key={index} sx={{ height: '40px' }}>
                <StyledTableCell sx={{ width: '20px', padding: '12px 12px', minWidth: '20px' }} />
                <StyledTableCell
                    sx={{
                        padding: '12px 12px',
                        width: '100px',
                        minWidth: '100px',
                        maxWidth: '100px',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ color: '#E4080A', marginRight: '4px' }}>*</Typography>
                        {row.name}
                        {row.tooltipInfo && (
                            <Tooltip
                                title={row.tooltipInfo}
                                arrow
                                componentsProps={{
                                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                    arrow: { sx: { color: '#272727' } },
                                }}
                            >
                                <InfoOutlinedIcon
                                    sx={{
                                        fontSize: '16px',
                                        color: '#005CBC',
                                        marginLeft: '8px',
                                        cursor: 'pointer',
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                </StyledTableCell>

                {/* Input cell - fixed width */}
                <StyledTableCell
                    sx={{
                        padding: '12px 12px',
                        width: '50px',
                        minWidth: '300px',
                        maxWidth: '300px',
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <StyleTextField
                            value={row.mvalue}
                            onChange={(e) => handleSamplingInputChange(index, 'mvalue', e.target.value)}
                            variant="filled"
                            sx={{
                                '&.MuiTextField-root': {
                                    border: 'none',
                                },
                                width: '200px',
                                border: `1px solid ${smartSamplingTagsErrors[`sampling_${index}`] ? '#d40020' : '#1378D4'}`,
                            }}
                            inputProps={{
                                style: { padding: '4px' },
                            }}
                        />
                        {smartSamplingTagsErrors[`sampling_${index}`] && (
                            <Typography
                                sx={{
                                    color: '#d40020',
                                    fontSize: '12px',
                                    marginTop: '4px',
                                    width: '200px',
                                }}
                            >
                                {smartSamplingTagsErrors[`sampling_${index}`]}
                            </Typography>
                        )}
                    </Box>
                </StyledTableCell>
            </Table>
        ))}
    </>
);

SmartSamplingTags.propTypes = {
    smartSampling: PropTypes.array.isRequired,
    smartSamplingTagsErrors: PropTypes.object.isRequired,
    handleSamplingInputChange: PropTypes.func.isRequired,
};

export default SmartSamplingTags;
